<template>
  <ContentPage>
    <template #header>
      <content-page-title>
        Dashboard
      </content-page-title>
    </template>

    <div class="d-flex">
      <v-btn-toggle
        v-model="chart"
        mandatory
        color="primary"
        background-color="white"
      >
        <v-btn small value="byService">Services</v-btn>
        <v-btn small value="byAccount">Sources</v-btn>
      </v-btn-toggle>
     <div class="ml-auto">
       <FilterDialog v-model="history_days" />
     </div>

    </div>

    <AccountChart
      v-if="chart==='byAccount'"
      :limit="bar_count"
      :days="history_days"
    />
    <ServiceChart
      v-if="chart==='byService'"
      :limit="bar_count"
      :days="history_days"
    />
    <!-- <Detail :account_ids="account_ids" :service_ids="service_ids" :days="history_days"/> -->
  </ContentPage>
</template>

<script>
  import { ContentPage, ContentPageTitle } from '@/components/pages'
  import FilterDialog from './FilterDialog'
  import { AccountChart, ServiceChart } from './charts'
  // import Detail from './Detail'

  export default {
    name: 'Reports',

    components: { ContentPage, ContentPageTitle, FilterDialog, AccountChart, ServiceChart },

    data() {
      return {
        chart: 'byService',
        bar_count: 7,
        history_days: 30,
        account_ids: [],
        service_ids: [],
      }
    },

    watch: {
      history_days() {
        this.reset()
      },

      chart() { 
        this.reset()
      },
    },

    methods: {
      reset() {
        this.account_ids = []
        this.service_ids = []
      },
    },
  }
</script>
